import React from "react";
import { graphql } from "gatsby";
import { ArboretumSearch } from "./ArboretumSearch";
import {
  KontentBrandColor,
  KontentComponentLayout,
  KontentComponentSettings,
  KontentMediaImage,
  KontentMultiChoice,
  KontentRichText,
  StringValue,
} from "../../../types";
import { getMultiChoice } from "../../../lib/multichoice";
import { getColor } from "../../../lib/color";
import { formatImages } from "../../../lib/images";

interface Props extends KontentComponentSettings, KontentComponentLayout {
  title: StringValue;
  subhead: StringValue;
  simple_rte__text: KontentRichText;
  background_color: {
    value: KontentBrandColor[];
  };
  body_copy_font_color: {
    value: KontentBrandColor[];
  };
  subhead_font_color: {
    value: KontentBrandColor[];
  };
  title_font_color: {
    value: KontentBrandColor[];
  };
  background_image: { value: KontentMediaImage[] };
  background_image_placement: KontentMultiChoice<"top_left" | "top_right">;
}

const ArboretumSearchContainer: React.FC<Props> = ({ ...props }) => {
  const image = formatImages(
    props.background_image?.value[0]?.elements
  )?.largeImage;

  return (
    <ArboretumSearch
      id={props.id}
      anchor={props.component_settings__anchor_name.value}
      width={getMultiChoice(props.component_layout__component_width)}
      hideOnMobile={
        getMultiChoice(props.component_settings__hide_on_mobile) === "yes"
      }
      title={props.title.value}
      titleColor={getColor(props.title_font_color)}
      subhead={props.subhead.value}
      subheadColor={getColor(props.subhead_font_color)}
      bodyCopy={props.simple_rte__text}
      bodyCopyColor={getColor(props.body_copy_font_color)}
      backgroundColor={getColor(props.background_color)}
      backgroundImage={image}
      backgroundImagePlacement={getMultiChoice(
        props.background_image_placement
      )}
    ></ArboretumSearch>
  );
};

export default ArboretumSearchContainer;

export const fragmentArboretumSearchContainer = graphql`
  fragment ArboretumSearch on kontent_item_component___arboretum_search {
    elements {
      component_settings__anchor_name {
        value
      }
      component_settings__hide_on_mobile {
        value {
          codename
        }
      }
      component_layout__component_width {
        value {
          codename
        }
      }
      title {
        value
      }
      subhead {
        value
      }
      simple_rte__text {
        ...kontentSimpleRichText
      }
      background_image {
        value {
          ...kontentMediaImage
        }
      }
      background_image_placement {
        value {
          codename
        }
      }
      background_color {
        ...brandColor
      }
      body_copy_font_color {
        ...brandColor
      }
      subhead_font_color {
        ...brandColor
      }
      title_font_color {
        ...brandColor
      }
    }
  }
`;
